"use strict";
// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Humla Health API
 * Humla Health API
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfOrientationOpportunityListCountsDto = instanceOfOrientationOpportunityListCountsDto;
exports.OrientationOpportunityListCountsDtoFromJSON = OrientationOpportunityListCountsDtoFromJSON;
exports.OrientationOpportunityListCountsDtoFromJSONTyped = OrientationOpportunityListCountsDtoFromJSONTyped;
exports.OrientationOpportunityListCountsDtoToJSON = OrientationOpportunityListCountsDtoToJSON;
exports.OrientationOpportunityListCountsDtoToJSONTyped = OrientationOpportunityListCountsDtoToJSONTyped;
/**
 * Check if a given object implements the OrientationOpportunityListCountsDto interface.
 */
function instanceOfOrientationOpportunityListCountsDto(value) {
    if (!('active' in value) || value['active'] === undefined)
        return false;
    if (!('archived' in value) || value['archived'] === undefined)
        return false;
    return true;
}
function OrientationOpportunityListCountsDtoFromJSON(json) {
    return OrientationOpportunityListCountsDtoFromJSONTyped(json, false);
}
function OrientationOpportunityListCountsDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'active': json['active'],
        'archived': json['archived'],
    };
}
function OrientationOpportunityListCountsDtoToJSON(json) {
    return OrientationOpportunityListCountsDtoToJSONTyped(json, false);
}
function OrientationOpportunityListCountsDtoToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'active': value['active'],
        'archived': value['archived'],
    };
}
//# sourceMappingURL=OrientationOpportunityListCountsDto.js.map